import ConversationAPI from '../../api/conversations';

const state = {
  inboxes: {},
  labels: {},
  teams: {},
};

const getters = {
  getInboxUnreadCount: $state => inboxId =>
    $state.inboxes[String(inboxId)] || 0,
  getLabelUnreadCount: $state => labelId => $state.labels[String(labelId)] || 0,
  getTeamUnreadCount: $state => teamId => $state.teams[String(teamId)] || 0,
};

const mutations = {
  SET_CONVERSATION_UNREAD_COUNTS($state, counts) {
    const normalize = obj =>
      Object.fromEntries(
        Object.entries(obj || {}).filter(([, v]) => Number(v) > 0)
      );
    $state.inboxes = normalize(counts.inboxes);
    $state.labels = normalize(counts.labels);
    $state.teams = normalize(counts.teams);
  },
  CLEAR_CONVERSATION_UNREAD_COUNTS($state) {
    $state.inboxes = {};
    $state.labels = {};
    $state.teams = {};
  },
};

const actions = {
  async get({ commit }) {
    try {
      const { data } = await ConversationAPI.getUnreadCounts();
      commit('SET_CONVERSATION_UNREAD_COUNTS', data.payload);
    } catch {
      // silently fail — feature may not be enabled
    }
  },
  clear({ commit }) {
    commit('CLEAR_CONVERSATION_UNREAD_COUNTS');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
